import React, { useCallback, useEffect, useState } from "react";
import Table from "../../../Table";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { GetAssets } from "../../../../redux/Assets/action";
import useInfiniteScroll from "../../../Hooks/useInfiniteScroll";
import dayjs from "dayjs";
import NoData from "../../../noData";

const SoldAssetsTable = ({ searchValue }) => {
  const [filter, setFilter] = useState({
    page: 1,
    limit: 10,
  });
  const [hasMoreData, setHasMoreData] = useState(true);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const getAssets = useSelector((state) => state?.Assets?.getAssets?.data);

  const tableHeading = {
    no: <div className="ml-5 text-center ">No.</div>,
    title: <div className="w-44 px-2  ">Title</div>,
    soldDate: <div className="text-center ">Sold Date</div>,
    soldAmount: <div className="text-center ">Sold Amount</div>,
    soldPaymentMethod: <div className="text-center ">Sold Payment Method</div>,
    buyingDate: <div className="text-center ">Buying Date</div>,
    buyAmount: <div className="text-center ">Buy Amount</div>,
    paymentMethod: <div className="mr-5 text-center ">Payment Method</div>,
  };

  const headData = Object.values(tableHeading);

  const bodyData = getAssets?.map((e, index) => {
    return {
      no: <div className="ml-5 text-center ">{index + 1}</div>,
      title: <div className="w-44 px-2  ">{e?.title}</div>,
      soldDate: (
        <div className="text-center ">
          {dayjs(e?.soldinfo?.date).format("DD/MM/YYYY")}
        </div>
      ),
      soldAmount: <div className="text-center ">{e?.soldinfo?.amount}</div>,
      soldPaymentMethod: (
        <div className="text-center ">
          {e?.soldinfo?.paymentmethod?.paymentmethod}
        </div>
      ),
      buyingDate: (
        <div className="text-center ">
          {dayjs(e?.date).format("DD/MM/YYYY")}
        </div>
      ),
      buyAmount: <div className="text-center ">{e?.amount}</div>,
      paymentMethod: (
        <div className="mr-5 text-center ">
          {e?.paymentmethod?.paymentmethod}
        </div>
      ),
    };
  });

  const fetchMoreData = useCallback(() => {
    if (hasMoreData) {
      setFilter((prev) => ({ ...prev, limit: prev.limit + 10 }));
    }
  }, [hasMoreData]);

  const lastElementRef = useInfiniteScroll(fetchMoreData);

  useEffect(() => {
    dispatch(
      GetAssets({
        page: filter?.page,
        limit: filter?.limit,
        type: true,
        search: searchValue,
      })
    ).then((res) => {
      if (res?.data?.status === 401) {
        navigate("/");
      }
      if (res?.data?.data?.length === 0) {
        setHasMoreData(false);
      }
    });
  }, [dispatch, navigate, filter, searchValue]);

  return (
    <>
      {getAssets?.length > 0 ? (
        <Table
          tableHeading={headData}
          tableData={bodyData}
          headingClass={"text-left"}
          lastElementRef={lastElementRef}
        />
      ) : (
        <NoData />
      )}
    </>
  );
};

export default SoldAssetsTable;
